/* eslint-disable react/no-unknown-property */
import Head from "node_modules/next/head";

import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import AboutUs from "components/templates/offshore/about-us";

import dataStatic from "./data.json";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="sg" page={data.page}>
        <Head>
          <link
            rel="alternate"
            href={`${process.env.NEXT_PUBLIC_HOME_URL}/hk/about-us`}
            hreflang="en-hk"
          />
          <link
            rel="alternate"
            href={`${process.env.NEXT_PUBLIC_HOME_URL}/sg/about-us`}
            hreflang="en-sg"
          />
          <link
            rel="alternate"
            href={`${process.env.NEXT_PUBLIC_HOME_URL}/offshore/about-us`}
            hreflang="en-us"
          />
          <link
            rel="alternate"
            href={`${process.env.NEXT_PUBLIC_HOME_URL}/offshore/about-us`}
            hreflang="en"
          />
          <link
            rel="alternate"
            href={`${process.env.NEXT_PUBLIC_HOME_URL}/vn/about-us`}
            hreflang="en-vi"
          />
        </Head>
        <AboutUs dataJson={dataStatic} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "sg";
  const uri = "/about-us";
  const page = await fetchSeo({
    uri,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
      },
      revalidate: 1,
    },
  };
};
